type Translate = (key: string) => string | null

/**
 * Lists the fields a 422 rejected, for the validation toast: the user may
 * have saved from a tab that does not show them (the whole work is sent
 * from every tab). Nested groups are named once:
 * `{ deceased: { birth_date: [...] } }` → `défunt (date de naissance)`.
 */
export function validationSummary(
  errors: unknown,
  translate: Translate,
  max = 6
): string {
  const label = (key: string) => translate(`attributes.${key}`) ?? key
  const parts: string[] = []
  if (!errors || typeof errors !== 'object') return ''
  for (const [key, value] of Object.entries(errors)) {
    if (Array.isArray(value)) {
      if (value.length && typeof value[0] === 'string') parts.push(label(key))
    } else if (value && typeof value === 'object') {
      const fields = Object.entries(value)
        .filter(([, v]) => Array.isArray(v) && v.length)
        .map(([k]) => label(k))
      if (fields.length) parts.push(`${label(key)} (${fields.join(', ')})`)
    }
  }
  if (parts.length > max) return `${parts.slice(0, max).join(', ')}…`
  return parts.join(', ')
}
